import { mc } from '@lss/common/game/characters/MC';
import Game from '../../src/shell/Game';
import ImageClass from "../../src/shell/Image";
import Question from '../../src/shell/Questions';
import { jump } from "../../src/shell/jump";
import { ann } from '../characters/Ann';
import { chris } from '../characters/Chris';
import { empty } from '../characters/empty';
import { images } from "./images";
import { V6AnnLibraryAfter } from './V6';
import { doImageShake, doTransition, doWaitImageByTime } from '../helpers/helpers';


export const V6AnnLibrary = async (): Promise<any> => {
    doTransition(images.v6.AnnLibraryNew_12);
    mc.think(`The library again...`);
    mc.think(`But where is Ann? She is not in her usual place...`);

    if (Question.globalAnswers.v1EnableNTR && Game.seenScenarios.includes(`V5AnnLibrary_Question`)) {

        return jump(V6AnnLibraryChris, "V6AnnLibraryChris");
    }
    return jump(V6AnnLibrary_Question, "V6AnnLibrary_Question");
};

export const V6AnnLibrary_Question = async (): Promise<any> => {
    doWaitImageByTime(images.v6.AnnLibraryNew_0);
    await mc.setQuestion(new Question({ text: `There she is.`, options: { think: true }, key: `v6AnnLibrarySpankedHerAss` })
        .option({ title: `Spank her ass`, key: true })
        .option({ title: `Cover her eyes`, key: false }));


    if (Question.globalAnswers.v6AnnLibrarySpankedHerAss) {
        return jump(V6AnnLibrary_Question_Spank, "V6AnnLibrary_Question_Spank");

    } else {

        return jump(V6AnnLibrary_Question_Eyes, "V6AnnLibrary_Question_Eyes");
    }
};


export const V6AnnLibraryChris = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_6);
    mc.think(`There she is... With Chris again.`);
    ann.talk(`Where is that book?`);
    chris.talk(`You tell me.`);
    ann.talk(`Maybe it's in the upper shelf, but I'm too short, I can't see.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_7);
    chris.talk(`There you go.`);
    ann.talk(`Oh! Hehe.`);
    ann.talk(`Nope, it's not here. You can put me down before your hands will start to hurt.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_8);
    chris.talk(`You are not heavy. I can lift you up for hours.`);
    ann.talk(`Hehe.`);

    ImageClass.setImage(images.v6.AnnLibraryNew_9);
    ann.talk(`${mc.name}!`);
    ImageClass.setImage(images.v6.AnnLibraryNew_22);
    ann.talk(`Hey! I didn't see you there.`);
    chris.talk(`Hey bro.`);
    mc.talk(`Hey.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_23);
    chris.talk(`Anyway, good luck finding that book. I need to go to the bar.`);
    ann.talk(`Oh, ok. Thanks for helping.`);
    chris.talk(`No problem.`);



    return jump(V6AnnLibrary_2, "V6AnnLibrary_2");
};



export const V6AnnLibrary_Question_Spank = async (): Promise<any> => {
    doImageShake(images.v6.AnnLibraryNew_1);
    // TODO: sound
    await mc.set((properties) => {
        properties.alpha++;
        properties.annRelationship++;
    });
    await ann.set((properties) => {
        properties.corruption++;
    });
    empty.think(`*Spank!*`);

    ImageClass.setImage(images.v6.AnnLibraryNew_2);
    ann.talk(`What??`);
    ann.talk(`Oh. ${mc.name}.`);
    mc.talk(`Did you think it was someone else?`);
    ImageClass.setImage(images.v6.AnnLibraryNew_3);
    ann.talk(`No... I kinda knew it was you I was just surprised. That's all.`);
    if (mc.properties.alpha >= 6) {
        mc.talk(`You told me to come and say hi, and that's how I do it.`);
        ann.talk(`Oh... Yeah I guess.`);
    } else {
        mc.talk(`I didn't know it would scare you...`);
        ImageClass.setImage(images.v6.AnnLibraryNew_5);
        ann.talk(`It's fine... I guess, hehe.`);
    }

    return jump(V6AnnLibrary_2, "V6AnnLibrary_2");
};


export const V6AnnLibrary_Question_Eyes = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_4);
    await mc.set((properties) => {
        properties.annRelationship += 2;
    });
    ann.talk(`What? Who is it?`);
    mc.talk(`...`);
    ann.talk(`${mc.name}? Is that you?`);

    ImageClass.setImage(images.v6.AnnLibraryNew_5);
    ann.talk(`Hehe, I knew it was you! I was hoping you'd come!`);

    ImageClass.setImage(images.v6.AnnLibraryNew_10);
    ann.talk(`Muah!`);


    return jump(V6AnnLibrary_2, "V6AnnLibrary_2");
};


export const V6AnnLibrary_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_3);
    mc.talk(`What are you searching for?`);
    ann.talk(`A book I thought they have here... But I guess I was wrong...`);
    ImageClass.setImage(images.v6.AnnLibraryNew_5);
    ann.talk(`Sometime I don't know why I'm coming here, I can find everything online.`);
    ann.talk(`I bet I can find it on my laptop in seconds!`);
    ann.talk(`Care to join me?`);
    mc.talk(`Sure. I came to see you.`);
    ann.talk(`Hehe!`);
    return jump(V6AnnLibrary_3, "V6AnnLibrary_3");
};


export const V6AnnLibrary_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_11, { duration: 1 });
    mc.talk(`What are you looking for?`);
    ImageClass.setImage(images.v6.AnnLibraryNew_13);
    ann.talk(`There is a condition called Goodpasture syndrome.`);
    ann.talk(`It's a rare disease that I've heard about and it keeps popping up on tests... So I thought I might check it out.`);
    mc.talk(`Never heard of it.`);
    ann.talk(`Me neither! That's why I'm searching for it. Hehe.`);
    ann.talk(`Goodpasture syndrome (GPS), also known as anti-glomerular basement membrane disease...`);
    return jump(AnnLibraryNew_3_Question, "AnnLibraryNew_3_Question");
};



export const AnnLibraryNew_3_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_13);
    await ann.setQuestion(new Question({ text: `Let's see what else I can find about that...`, options: { think: false, array: "v6AnnLibraryTouchStatusArr" }, key: `v6AnnLibraryTouchStatus` })
        .option({ title: `Let her search`, key: `letHerSearch` })
        .option({ title: `Touch her`, key: `touchHer`, hide: Question.globalAnswers?.v6AnnLibraryTouchStatusArr?.includes('touchHer') })
        .option({ title: `Touch her again`, key: `touchHerAgain`, hide: Question.globalAnswers?.v6AnnLibraryTouchStatusArr?.includes('touchHerAgain'), show: Question.globalAnswers?.v6AnnLibraryTouchStatusArr?.includes('touchHer') })
        .option({ title: `Make her touch you`, key: `makeHerTouchYou`, hide: Question.globalAnswers?.v6AnnLibraryTouchStatusArr?.includes('makeHerTouchYou'), show: Question.globalAnswers?.v6AnnLibraryTouchStatusArr?.includes('touchHerAgain') }));


    if (Question.globalAnswers.v6AnnLibraryTouchStatus === "letHerSearch") {
        return jump(AnnLibraryNew_3_Question_Search, "AnnLibraryNew_3_Question_Search");

    } else if (Question.globalAnswers.v6AnnLibraryTouchStatus === "touchHer") {
        return jump(AnnLibraryNew_3_Question_Touch, "AnnLibraryNew_3_Question_Touch");

    } else if (Question.globalAnswers.v6AnnLibraryTouchStatus === "touchHerAgain") {
        return jump(AnnLibraryNew_3_Question_Touch2, "AnnLibraryNew_3_Question_Touch2");

    } else {
        return jump(AnnLibraryNew_3_Question_Touch3, "AnnLibraryNew_3_Question_Touch3");

    }

};



export const AnnLibraryNew_3_Question_Search = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_14);
    ann.talk(`It also says it's a genetics diseases... Interesting.`);
    ann.talk(`The symptoms are: fatigue, nausea, trouble breathing and pale skin.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_15);
    ann.talk(`Pale skin? I hope I don't have it, hehe.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_14);
    ann.talk(`Oh... There is a lot of reading to do.`);


    return jump(AnnLibraryNew_3, "AnnLibraryNew_3");
};



export const AnnLibraryNew_3_Question_Touch = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_16);
    await ann.set((properties) => {
        properties.corruption++;
    });
    ann.talk(`Oh!`);
    ann.talk(`${mc.name}!`);
    ImageClass.setImage(images.v6.AnnLibraryNew_17);
    ann.talk(`What are you doing? People are looking!`, { method: "Whispering" });
    mc.talk(`Come on... Let me touch you.`);
    ann.talk(`Here?`);
    ann.talk(`I had a really good time yesterday but... It was in my room...`, { method: "Whispering" });
    mc.talk(`Sure.`);
    return jump(AnnLibraryNew_3_Question, "AnnLibraryNew_3_Question");
};

export const AnnLibraryNew_3_Question_Touch2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_18);
    await ann.set((properties) => {
        properties.corruption++;
    });
    ann.talk(`It's a raree...... OH!`);
    ann.talk(`${mc.name}!`, { method: "Whispering" });
    ImageClass.setImage(images.v6.AnnLibraryNew_19);
    ann.talk(`You said you'd stop!`);
    mc.talk(`I can't. I'm horny.`);
    ann.talk(`We can do it later! At my room!`, { method: "Whispering" });
    mc.talk(`Why not here?`);
    ann.talk(`I come here all of the time, people know me.`, { method: "Whispering" });
    ann.talk(`I'm just gonna continue reading.`);


    return jump(AnnLibraryNew_3_Question, "AnnLibraryNew_3_Question");
};



export const AnnLibraryNew_3_Question_Touch3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnLibraryNew_20);
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.talk(`So at least touch me for a bit.`);
    ann.talk(`${mc.name}!`);
    ann.talk(`Oh...Hehe, it's hard...`, { method: "Whispering" });
    mc.talk(`I told you.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_21);
    ann.talk(`Oh no, that guy over there is looking at us.`);
    ImageClass.setImage(images.v6.AnnLibraryNew_17);
    ann.talk(`I hope he didn't see anything!`);
    mc.talk(`What if he did?`);
    ann.talk(`I would be ashamed to show my face here...`);
    mc.talk(`We are in a relationship... It's obvious we do these kind of things.`);
    ann.talk(`Not in front of everyone to see...`);
    ann.talk(`I've also never seen people do that in public...`);
    mc.talk(`Maybe you just don't hang out in the right places...`);
    ann.talk(`I guess...`);

    return jump(AnnLibraryNew_3, "AnnLibraryNew_3");
};

export const AnnLibraryNew_3 = async (): Promise<any> => {

    if (Game.seenScenarios.includes(`AnnLibraryNew_3_Question_Touch3`)) {

        ImageClass.setImage(images.v6.AnnLibraryNew_15_2);
        ann.talk(`${mc.name}, thanks for coming but I really have a lot of stuff to go over.`);
        mc.talk(`Is that a nice way to tell me to go home?`);
        ann.talk(`Don't get it the wrong way! I was the one who asked you to come here... For a visit.`);
        mc.talk(`Sure.`);
        ann.talk(`Don't get mad or anything.`);
        mc.talk(`Don't worry. It's all good.`);
        mc.talk(`I'll cya later.`);
        ann.talk(`Bye, ${mc.name}.`);
    } else {

        ImageClass.setImage(images.v6.AnnLibraryNew_15);
        mc.talk(`Are you hinting that you want me to go?`);
        ann.talk(`Oh no! You can stay. I can read it to you if you want to.`);

        mc.talk(`That's ok, I'll be on my way.`);
        ImageClass.setImage(images.v6.AnnLibraryNew_15_2);
        ann.talk(`Now I feel bad... You came just for me and I feel like I'm trying to get rid of you so fast.`);
        mc.talk(`That's fine, the library was on my way home. No harm was done.`);
        ImageClass.setImage(images.v6.AnnLibraryNew_15);
        ann.talk(`Oh ok. Thanks for coming! You made my day! Hehe.`);
        mc.talk(`Bye Ann.`);
    }
    return jump(V6AnnLibraryAfter, "V6AnnLibraryAfter");
};